// extracted by mini-css-extract-plugin
export default {"container":"Video_container__xQ8gl","video":"Video_video__UHyCz"};